import { Directive, ElementRef, Input, AfterViewInit, ChangeDetectorRef } from '@angular/core';
 
@Directive({
  selector: '[jhiMoveToSlot]',
})
export class MoveToSlotDirective implements AfterViewInit {
  @Input() slotName!: string;
  @Input() parentElement!: HTMLElement;
 
  constructor(private el: ElementRef, private cdr: ChangeDetectorRef) {}
 
  ngAfterViewInit(): void {
    setTimeout(() => {
      const elementToMove = this.el.nativeElement;
      const shadowRoot = this.parentElement.shadowRoot;
      if (shadowRoot) {
        const slot = shadowRoot.querySelector(`slot[name="${this.slotName}"]`);
        if (slot) {
          slot.appendChild(elementToMove);
        }
      }
 
      this.cdr.detectChanges();
    }, 0);
  }
}